import { ExtractedRow } from '../models/extracted-values';
import { toCents } from './Money.utils';

export function calculateSumOfCurrencyColumnInCents(extractedRows: ExtractedRow[], key: string) {
  const values = extractedRows.map((row) => (row.rowData?.[key]!.value as number) ?? 0);
  return values.map(toCents).reduce((a, b) => a + b, 0);
}
